/*

Base Grade Function
  if (finnance or gaming)

    get the license
    get license grade

  else

    get the grade from the risk


Base Grade

  switch (country tier)

   case tier 1: +
   case tier 2: none
   case tier 3: -
   case tier 4: base grade > F


if (startup)
  base grade -

if (existing && Volume above 500k)
  base grade +


 */

export const grades = {
  0: 'F',
  1: 'C-',
  2: 'C',
  3: 'C+',
  4: 'B-',
  5: 'B',
  6: 'B+',
  7: 'A-',
  8: 'A',
  9: 'A+',
};

export enum Grade {
  'A+' = 9,
  'A' = 8,
  'A-' = 7,
  'B+' = 6,
  'B' = 5,
  'B-' = 4,
  'C+' = 3,
  'C' = 2,
  'C-' = 1,
  'F' = 0,
}

enum Tier {
  One = 'Tier 1',
  Two = 'Tier 2',
  Three = 'Tier 3',
  Four = 'Tier 4 - Prohibited',
}

enum Risk {
  Low = 'Low Risk',
  Medium = 'Medium Risk',
  High = 'High Risk',
  Prohibited = 'Prohibited',
}

enum CompanyType {
  Startup = 'Startup',
  Existing = 'Existing Company',
}

enum Industry {
  Financial = 'Financial Services',
  Gaming = 'Gaming'
}

enum MonthlyVolume {
  Lowest = '0 - 100K',
  Lower = '100K - 500K',
  Medium = '500K - 2M',
  High = '2M - 5M',
  Highest = '5M - And Above',
}

const ALicenses = [
  'FCA - Financial Services Authority (United Kingdom)',
  'MGA - Maltese Gaming Authority',
  'NFA - National Futures Association (USA)',
  'SEC - U.S Securities and Exchange Commission', // TODO SEC (USA) in the document
  'FINRA - Financial Industry Regulatory Authority, Inc. (USA)'
];

const BLicenses = [
  'CySEC - Cyprus Securities and Exchange Commission', // TODO CySec in the document
  'BaFin - Federal Financial Supervisory Authority',
  'FINMA - Swiss Financial Market Supervisory Authority ',
  'FMA - Financial Market Authority (Austria)',
  'CBFA - Banking Finance and Insurance Commission',
  'Hanfa - Financial Services Supervisory Agency',
  'FSC - Financial Supervision Commission of Bulgaria',
  'DFSA - Danish Financial Supervisory Authority',
  'AMF - Autorite des Marches Financiers',
  'Isle of Man Gambling Supervision Commission',
  'HCMC - Capital Market Commission',
  'HFSA - Hungarian Financial Supervisory Authority',
  'CBI - Central Bank of Ireland',
  'CONSOB - Commissione Nazionale per le Società e la Borsa',
  'LSC - Securities Commission of the Republic of Lithuania',
  'CSSF - Commission de Surveillance du Secteur Financier',
  'MFSA - Malta Financial Services Authority',
  'AFM - Authority for the Financial Markets',
  'KNF - Polish Financial Supervision Authority',
  'CNVM - Romanian National Securities Commission',
  'FI - Financial Supervisory Authority of Sweden',
  'FME - Icelandic Financial Supervisory Authority',
  'FMA - Financial Market Authority',
  'ASIC - Australian Securities and Investments Commission',
  'FSP - New Zealand Financial Service Provider',
  'Curacao Gambling License'
];

const CLicenses = [
  'IFSC - International Financial Services Commission',
  'FSA Mauritius - Mauritius Financial Services Commission',
  'FSA Seychelles - Seychelles Financial Services Authority',
  'SVGFSA - St. Vincent and the Grenadines Financial Services Authority',
  'CySEC - Cyprus Securities and Exchange Commission',
  'BVIFSC - British Virgin Islands Financial Services Commission',
  'SBC - Securities Commission of The Bahamas'
];

const FLicenses = [
  'KGC - Kahnawake Gaming Commission',
  'VFSC - Vanuatu Financial Services Commission'
];

export interface GradeData {
  mainIndustry: string;
  subIndustry: string;
  industryRisk: string;
  licence: string;
  licenceRisk: string;
  countryTier: string;
  companyType: string;
  expectedMonthlyVolume: string;
}

export const getGrade = (data: GradeData): Grade => {

  let baseGrade: Grade = Grade.F;

  if (data.mainIndustry === Industry.Financial || data.mainIndustry === Industry.Gaming) {

    // Document specification rules
    if (ALicenses.includes(data.licence)) {
      baseGrade = Grade.A;

    } else if (BLicenses.includes(data.licence)) {
      baseGrade = Grade.B;

    } else if (CLicenses.includes(data.licence)) {
      baseGrade = Grade.C;

    } else if (FLicenses.includes(data.licence)) {
      return Grade.F;

    // Static data risk
    } else if (data.licenceRisk === Risk.Low) {
      baseGrade = Grade.A

    } else if (data.licenceRisk === Risk.Medium) {
      baseGrade = Grade.B

    } else if (data.licenceRisk === Risk.High) {
      baseGrade = Grade.C

    } else if (data.licenceRisk === Risk.Prohibited) {
      return Grade.F;

    } else if (data.licence === 'no-licence') {
      return Grade.F;
    }

    // If it is NOT financial services or gaming -->
  } else {

    if (data.industryRisk === Risk.Low) {
      baseGrade = Grade.A;

    } else if (data.industryRisk === Risk.Medium) {
      baseGrade = Grade.B;

    } else if (data.industryRisk === Risk.High) {
      baseGrade = Grade.C;

    } else if (data.industryRisk === Risk.Prohibited) {
      return Grade.F;
    }
  }

  // Checking the country tier
  switch (data.countryTier) {

    case Tier.One:
      baseGrade = baseGrade + 1;
      break;

    case Tier.Two:
      break;

    case Tier.Three:
      baseGrade = baseGrade - 1;
      break;

    case Tier.Four:
      return Grade.F;
  }

  // Checking the company type
  if (data.companyType === CompanyType.Startup) {
    baseGrade = baseGrade - 1;
  }

  if (data.companyType === CompanyType.Existing && data.expectedMonthlyVolume === MonthlyVolume.Medium) {
    baseGrade = baseGrade + 1;
  }

  if (data.companyType === CompanyType.Existing && data.expectedMonthlyVolume === MonthlyVolume.High) {
    baseGrade = baseGrade + 1;
  }

  if (data.companyType === CompanyType.Existing && data.expectedMonthlyVolume === MonthlyVolume.Highest) {
    baseGrade = baseGrade + 1;
  }

  if (baseGrade < 0 ) {
    baseGrade = Grade.F;
  }


  return baseGrade;
};